import script from "./NationalityFlag.vue?vue&type=script&setup=true&lang=js"
export * from "./NationalityFlag.vue?vue&type=script&setup=true&lang=js"

import "./NationalityFlag.vue?vue&type=style&index=0&id=6603dadf&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6603dadf"]])

export default __exports__